import { render, staticRenderFns } from "./Plantas.vue?vue&type=template&id=4c56a62a&scoped=true&lang=pug"
import script from "./Plantas.vue?vue&type=script&lang=js"
export * from "./Plantas.vue?vue&type=script&lang=js"
import style0 from "./Plantas.styl?vue&type=style&index=0&id=4c56a62a&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c56a62a",
  null
  
)

export default component.exports